var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMemo } from 'react';
import { Api_Sharelink_Param_Type } from '@core/api';
import { logError } from '@core/logging';
import { SHARE_LINK_PARAM } from '@embed/constants';
import { decorateWithFWReferrer } from '@embed/helpers';
import { useApi } from './useApi';
import { useLiveStreamActiveWhitelist } from './useLiveStreamActiveWhitelist';
export const useFirstPartyLiveStream = (props) => {
    const { appContext, params, video } = props;
    const apiService = useApi();
    const isWhitelisted = useLiveStreamActiveWhitelist();
    const isFirstPartyLiveStream = useMemo(() => isWhitelisted ||
        (() => {
            try {
                if (!video ||
                    video.video_type !== 'live_stream' ||
                    !video.canonical_url) {
                    return true;
                }
                if (!(params === null || params === void 0 ? void 0 : params.page_url)) {
                    return false;
                }
                const currentUrl = new URL(params.page_url);
                const firstPartyUrl = new URL(video.canonical_url);
                if (firstPartyUrl.origin !== currentUrl.origin) {
                    return false;
                }
                return true;
            }
            catch (e) {
                logError(e);
                return true;
            }
        })(), [isWhitelisted, params === null || params === void 0 ? void 0 : params.page_url, video]);
    const firstPartyUrlPromise = useMemo(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        if (isFirstPartyLiveStream) {
            return null;
        }
        if (!video || !params) {
            return null;
        }
        const shareLink = yield apiService.getShareLink({
            base_url: decorateWithFWReferrer({
                url: (_a = video === null || video === void 0 ? void 0 : video.canonical_url) !== null && _a !== void 0 ? _a : '',
                video,
                appContext,
                params,
            }),
            param_type: Api_Sharelink_Param_Type.QUERY,
            param_key: SHARE_LINK_PARAM,
            channel: video === null || video === void 0 ? void 0 : video.creator.username,
            video_id: (_b = video === null || video === void 0 ? void 0 : video.encoded_id) !== null && _b !== void 0 ? _b : '',
        });
        return shareLink ? shareLink.url : null;
    }), [isFirstPartyLiveStream, apiService, video, appContext, params]);
    return useMemo(() => {
        const openInFirstParty = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const url = yield firstPartyUrlPromise;
                if (url) {
                    window.open(url, 'firstparty');
                }
            }
            catch (e) {
                logError(e);
            }
        });
        return { isFirstPartyLiveStream, openInFirstParty };
    }, [isFirstPartyLiveStream, firstPartyUrlPromise]);
};
